import defaultAxios, {fileResourceAxios} from "lib/http/http.common"
import {FileResource, RealDevice} from "dto/realdevice/devices"
import {ApiResponse} from "api/common/response"
import {ImageFile} from "dto/file-resource/file-resource"
import FileSaver from "file-saver"
import dayjs from "dayjs";

// export const registerRealDevice = useMutation(realDevice => defaultAxios.post('/')

const register = (device: RealDevice) => {
    return defaultAxios.post('/real-device', device)
}

const update = (device: RealDevice) => {
    return defaultAxios.put(`/real-device/${device.id}`, device)
}
// const findAll = (page: number = 0, ) => {
//     return defaultAxios.get<ApiResponse<PageableListResponse<RealDevice>>>(`/real-device?page=${page}`)
// }

const deleteDevice = (id: number) => {
    return defaultAxios.delete(`real-device/${id}`)
}

const findAll = () => {
    // return defaultAxios.get<ApiResponse<PageableListResponse<RealDevice>>>(`/real-device?page=${page}`)
    return defaultAxios.get<ApiResponse<RealDevice[]>>(`/real-device/all`)
}

const uploadImage = (file: File) => {
    const formData = new FormData()
    formData.append("file", file)
    return defaultAxios.post<ApiResponse<FileResource>>("/file-service", formData)
}

const uploadImages = (files: File[]) => {
    const formData = new FormData()
    files.forEach(file => {
            formData.append("files", file)
        }
    )
    return fileResourceAxios.post<ImageFile[]>("/uploadMultipleFiles", formData)
}

const downloadExcel = async () => {
    try {
        const response = await defaultAxios.get('/real-device/all/excel', {
            responseType: 'blob', // Important
        });

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, 'real-devices.xlsx');
    } catch (error) {
        console.error('Error downloading the Excel file', error);
    }
};

const downloadDeviceStatusExcel = async (date: Date) => {
    const year = dayjs(date).format('YYYY');
    const month =  dayjs(date).format('MM')
    try {
        const response = await defaultAxios.get(`/real-device/status/excel?month=${month}&year=${year}`, {
            responseType: 'blob', // Important
        });

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, 'device-status.xlsx');
    } catch (error) {
        console.error('Error downloading the Excel file', error);
    }
};

export const RealDeviceApi = {
    register,
    findAll,
    update,
    deleteDevice,
    uploadImage,
    uploadImages,
    downloadExcel,
    downloadDeviceStatusExcel,
}